import React from 'react';
import {WebView, WebViewNavigation} from 'react-native-webview';
import {useDispatch} from 'react-redux';
import querystring from 'querystring';
import {useStyles} from '../../../../shared/hooks/styles';
import {SnackbarNotificationType} from '../../../../shared/components/snackbar/model';
import {addNotification} from '../../../../redux/actions/snackbar';
import {dobroruActions} from '../../../../redux/reducers/dobroru';
import Screen from '../../../../shared/components/screen';
import {loginDobroru} from '../../../../redux/actions/dobroru';

// todo: уточнить все url
export const LK_TEST_ESKMO = 'https://test-lk-murmansk.eskso.ru';
export const LK_PROD_ESKMO = 'https://lk.karta51.ru';

export const DobroWebView = ({link}: {link: string}) => {
  const styles = useStyles(({theme}) => ({
    root: {
      paddingBottom: 40,
      backgroundColor: theme.color.backgroundMenuColor,
    },
    webView: {flex: 1},
  }));
  const dispatch = useDispatch();
  const onNavigationStateChange = ({url}: WebViewNavigation) => {
    if (!url || !(url.startsWith(LK_PROD_ESKMO) || url.startsWith(LK_TEST_ESKMO))) return;

    const [, params = ''] = url.split('?');
    const {code} = querystring.parse(params);

    dispatch(dobroruActions.setLink(null));
    if (code && typeof code === 'string') {
      dispatch(loginDobroru(code));
    } else {
      dispatch(
        addNotification({
          message: 'Не удалось получить код авторизации на портале добро.ру',
          type: SnackbarNotificationType.Error,
        }),
      );
    }
  };

  return (
    <Screen style={styles.root}>
      <WebView
        scalesPageToFit
        startInLoadingState
        androidHardwareAccelerationDisabled
        thirdPartyCookiesEnabled
        cacheEnabled={false}
        mixedContentMode='compatibility'
        source={{uri: link ?? ''}}
        containerStyle={styles.webView}
        onNavigationStateChange={onNavigationStateChange}
      />
    </Screen>
  );
};
